<template>
  <v-list :max-height="maxHeight" style="overflow-y: auto">
    <v-list-item v-for="branch in branches"
                 :to="'/building/'+branch.Branch_ID" :key="branch.Branch_ID"> 
      <v-list-item-action>
        <v-icon>mdi-domain</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ branch.BranchAddress }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ branch.PartnerBrandName }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon>mdi-chevron-right</v-icon>
      </v-list-item-action>
    </v-list-item>

  </v-list>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BuildingList",
  props: {maxHeight: {type: String, default: null, required: false}},
  computed: {
    ...mapGetters([
      "branches",
      "isMobile",
      "userDetails"
    ]),
  }

}
</script>

<style scoped>

</style>
